import api from './api';

export function getUfs() {
  return api.get('cidade/public/list-ufs');
}
export function getCidades(uf: string) {
  return api.get(`cidade/public/list-por-uf/${uf}`);
}
